import React from 'react';

import BackButton from '@/components/BackButton/BackButton';
import DeviceHero from '@/components/DeviceHero/DeviceHero';
import ROUTE_PATHS from '@/consts/route/routePaths';
import HomePageTopNavigation from '@/containers/HomePageTopNavigation/HomePageTopNavigation';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import {twx} from '@/utils/tailwindUtils';
import HomePageLayout from '@/views/Home/HomePageLayout';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

const AdvancedDiagnosticLayout = ({className, children}) => {
    const isMobile = useIsMobileLayout();

    return isMobile ? (
        children
    ) : (
        <HomePageLayout
            className={twx('bg-primary-dark-5 ml:flex ml:flex-col ml:items-center', className)}
            activePath={ROUTE_PATHS.DEVICES_PAGE}
        >
            <HomePageTopNavigation profileControlsClassName='bg-romance' />
            {children}
            <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.AD} />
        </HomePageLayout>
    );
};

const ContentWrapper = ({className, children, hideHw}) => {
    const isMobile = useIsMobileLayout();

    return (
        <div
            className={twx(
                'flex w-full flex-1 flex-col pt-8 ml:max-w-[570px] ml:items-center ml:justify-center ml:px-8 ml:pb-10 ml:pt-0',
                className
            )}
        >
            {children}
            {isMobile && !hideHw && <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.AD} />}
        </div>
    );
};

const Container = ({className, sectionClassName, children, isDeviceHero, onBackButtonClick}) => {
    const isMobile = useIsMobileLayout();
    const isShowBackButton = !isMobile && onBackButtonClick;

    return (
        <div className={twx('flex w-full flex-1 flex-col overflow-hidden pt-0-hw-offset ml:pt-0', className)}>
            <WarningBannersTop source={WARNING_BANNER_SOURCE_TYPES.AD} className='ml:pl-[var(--sidebar-width)]' />
            <div
                className={twx(
                    'pt-safe-offset-sticky-header relative flex flex-1 flex-col items-center pb-4 ml:pb-0',
                    isMobile && isDeviceHero && 'pt-12'
                )}
            >
                <section
                    className={twx(
                        'flex w-full flex-1 flex-col items-center ml:justify-center ml:text-center',
                        sectionClassName,
                        isMobile && (isDeviceHero ? 'px-0' : 'px-6')
                    )}
                >
                    {isDeviceHero && isMobile && <DeviceHero containerClassName='w-full mb-9 -mt-12' />}
                    {isShowBackButton && <BackButton onClick={onBackButtonClick} className='absolute left-8 top-5' />}
                    {children}
                </section>
            </div>
        </div>
    );
};

AdvancedDiagnosticLayout.ContentWrapper = ContentWrapper;
AdvancedDiagnosticLayout.Container = Container;

export default AdvancedDiagnosticLayout;
